import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';

import { useStore } from 'core/store';
import useStyles from '../policy-sidebar.styles';
import SegmentItem from './segment-item';

function SegmentList({ segments, isSectionActive, policyType }) {
  const classes = useStyles();
  const [active, setActive] = useState(0);
  const {
    account: {
      policies: {
        policy: { preview }
      }
    }
  } = useStore();

  const targetSegmentId = preview?.changeDetails?.targetSegmentId;
  const targetSegmentIndex = segments.findIndex((s) => s.id === targetSegmentId);

  return (
    <div className={classes.segmentsContainer}>
      <ul className={classes.segmentsList}>
        {segments.map((segment, i) => (
          <SegmentItem
            key={segment.segmentId}
            segment={segment}
            policyType={policyType}
            active={i === active && isSectionActive}
            lastChild={i + 1 === segments.length}
            onClick={() => setActive(i)}
            singleVersion
            isDraft={(targetSegmentIndex === -1 ? i === 0 : i === targetSegmentIndex) && !!preview}
            isNewChange={targetSegmentIndex === -1}
          />
        ))}
      </ul>
    </div>
  );
}

SegmentList.propTypes = {
  segments: PropTypes.array,
  isSectionActive: PropTypes.bool,
  policyType: PropTypes.string.isRequired
};

SegmentList.defaultProps = {
  segments: [],
  isSectionActive: true
};

export default memo(SegmentList);
